import clsx from 'clsx';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-duotone-svg-icons';

//Styles
import './checkbox.scss';


export interface CheckboxProps {
    text?: string;
    isActive?: boolean;
    toggleCheckbox?: () => void;
}

const Checkbox = (props: CheckboxProps) => {    
    return (
        <div    
            className={clsx("checkbox", props.isActive && "active")} 
            onClick={props.toggleCheckbox}
        >
            <div className="box-wrap">
                <div className="box">
                    <FontAwesomeIcon icon={faCheck} className="icon" />
                </div>
            </div>
            <span>{props.text}</span>
        </div>
    )
}

export default Checkbox;